module.exports = __webpack_public_path__ + "img/img-4c3f3c.png";